"use client";
import { Components } from "@mui/material";
import { Theme } from "@mui/material/styles";

type muiCollapseOverrides = Components<Theme>["MuiCollapse"];

export const muiCollapseStyles: muiCollapseOverrides = {
  styleOverrides: {
    root: {
      "&.MuiCollapse-vertical": {
        width: "100%",
      },
    },
  },
};
